import React from 'react';
import homeabout from '../assests/img/home-about.png';


function About() {
  return (
    <>
      <section className="home-about">
        <div className="container">
          <div className="row">
            <div className='about-img home-about-banner col-md-4'>
            <img src={homeabout} />
            </div>
            <div className='about-text col-md-8'>
              <h2>“LABWAY” is recognized as a leading & reliable Manufacturer and Exporter of Scientific Laboratory Instruments, Science & Math Kits and Educational Apparatus.</h2>
             <p>“LABWAY” aim to provide the best, most engaging and innovative Science & Educational products. “LABWAY” have been producing & selling equipment that is used in Schools, Colleges, Training Institutes & for Lab technicians.</p>

<p>The product range has now grown to more than 2000 units & systems. It is constantly being updated & expanded with new equipments. This allows us to cover all the aspects of training in education related areas. We also welcome any custom designs according to END USER’s specifications and requirements.</p>

<p>It is our mission to supply only the best quality of products to the customers at the best price. It is through our hard work and continuous effort that we have been able to achieve this and we strive to keep our customers happy at all times.</p>
            </div>
          </div>
        </div>
      </section>
      
    </>
  )

}

export default About;
